import register_dom_update from "../navigation/register_dom_update"
import user from "../state/user"

function update_user_data(_, event) {
  if (event.detail?.counter) {
    // @ts-expect-error TS2339
    user.refresh()
  }
}
register_dom_update({
  after: update_user_data,
})
